import { defineMessage } from 'services/localization';

export const messages = {
    payDescription: defineMessage('the_smarter_faster_way__directly_in_approvalmax'),
    captureDescription: defineMessage('automated_invoice_data___seconds_free_documents'),
    tryNowButtonText: defineMessage('try_now'),
};
